// Mock data for Sean Greenwood website

export const siteConfig = {
  name: "Sean Greenwood",
  tagline: "Building Legacies Through Strategic Property & Business Excellence",
  logo: "https://customer-assets.emergentagent.com/job_sean-realty-hub/artifacts/gwq7c4x4_51E1E1E8-1B14-4221-9B55-E51492EFA056.png",
  calendlyUrl: "https://calendly.com/seangreenwood-consultant",
  email: "sg@seangreenwood.com",
  phone: "508-360-2370"
};

export const navigation = [
  { name: "Home", href: "#home" },
  { name: "About", href: "#about" },
  { name: "Services", href: "#services" },
  { name: "Portfolio", href: "#portfolio" },
  { name: "Testimonials", href: "#testimonials" },
  { name: "Contact", href: "#contact" }
];

export const aboutData = {
  headline: "Trusted Real Estate & Business Management Expert",
  description: "With experience in real estate investment, property management, and business consulting, Sean Greenwood has built a reputation for delivering results. His strategic approach combines market expertise with personalized service to help clients achieve their property and business goals.",
  highlights: [
    { label: "Years Experience", value: "10+" },
    { label: "Properties Managed", value: "50+" },
    { label: "Happy Clients", value: "100+" },
    { label: "Active Ventures", value: "4" }
  ]
};

export const services = [
  {
    id: 1,
    title: "Property Management",
    description: "Comprehensive property management services including tenant relations, maintenance coordination, and financial reporting for residential and commercial properties.",
    icon: "Building2"
  },
  {
    id: 2,
    title: "Real Estate Investment",
    description: "Strategic investment guidance for acquiring, developing, and maximizing returns on real estate portfolios across diverse markets.",
    icon: "TrendingUp"
  },
  {
    id: 3,
    title: "Business Consulting",
    description: "Expert consulting services to help businesses optimize operations, expand strategically, and achieve sustainable growth.",
    icon: "Briefcase"
  },
  {
    id: 4,
    title: "Vacation Rentals",
    description: "Professional management of vacation rental properties with marketing, guest services, and revenue optimization strategies.",
    icon: "Home"
  }
];

export const portfolio = [
  {
    id: 1,
    name: "Greenwood Property Group",
    description: "Full-service real estate and property management company serving diverse markets.",
    url: "https://greenwoodpropertygroup.com",
    category: "Property Management"
  },
  {
    id: 2,
    name: "Coastal Homes Realty Group",
    description: "Licensed real estate agent providing personalized buying and selling services for residential clients.",
    url: "https://seangreenwood.chrealtygroup.com",
    category: "Real Estate Agent"
  },
  {
    id: 3,
    name: "Greenwood Hill Cabin Rentals",
    description: "Cabin vacation rentals offering memorable getaway experiences.",
    url: "https://greenwoodhillcabinrentals.com",
    category: "Vacation Rentals"
  },
  {
    id: 4,
    name: "Preserves of Cape Cod",
    description: "Professional business management and operational consulting services.",
    url: "https://preservesofcapecod.com",
    category: "Business Management"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Michael Thompson",
    role: "Property Investor",
    content: "Sean's expertise in real estate investment has been invaluable. His strategic guidance helped me grow my portfolio significantly while minimizing risk.",
    rating: 5
  },
  {
    id: 2,
    name: "Sarah Mitchell",
    role: "Business Owner",
    content: "Working with Sean transformed our business operations. His consulting approach is thorough, practical, and results-driven.",
    rating: 5
  },
  {
    id: 3,
    name: "David Chen",
    role: "Vacation Rental Owner",
    content: "The management of our vacation properties exceeded expectations. Bookings increased 40% in the first year under Sean's team.",
    rating: 5
  }
];
